import { render, staticRenderFns } from "./TransferOfShares.vue?vue&type=template&id=0dc0e7c2&scoped=true&"
import script from "./TransferOfShares.vue?vue&type=script&lang=js&"
export * from "./TransferOfShares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc0e7c2",
  null
  
)

export default component.exports